import { render, staticRenderFns } from "./BrandStoryPage.vue?vue&type=template&id=19aa790e&scoped=true&"
import script from "./BrandStoryPage.vue?vue&type=script&lang=js&"
export * from "./BrandStoryPage.vue?vue&type=script&lang=js&"
import style0 from "./BrandStoryPage.vue?vue&type=style&index=0&id=19aa790e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa790e",
  null
  
)

export default component.exports